import NotificationUpdate from "../../components/refreshCareerMatches/notificationUpdate";

export default NotificationUpdate;